module.exports = __webpack_public_path__ + "static/media/copyLink.6f3190fc.svg";